const editIconTitle = "Edit";
const SOCIAL_ICON_SIZE = 20;
const RESUME_WIDTH = 900;
const RESUME_HEIGHT = RESUME_WIDTH * 1.29;
export { editIconTitle, SOCIAL_ICON_SIZE, RESUME_WIDTH, RESUME_HEIGHT };
